const pathnames = {
	login: "/",
	app: "/app",
	profile: "/profile",
	dashboard: "/dashboard",
	maintenance: "/maintenance",
	leaves: "/leave-management/leaves",
	leavesHistory: "/leave-management/leave-history",
	leavesSummary: "/leave-management/leave-summary",
	leavesPending: "/leave-management/leaves-pending",
	leavesUpcoming: "/leave-management/leave-upcoming",
	leavesApproval: "/leave-management/leaves-approval",
	leaveRequests: "/leave-management/leave-requests",
	leavesDirectory: "/leave-management/leave-directory",
	leavesOverview: "/leave-management/leave-overview",
	overtimePending: "/overtime-management/overtime-pending",
	overtimeHistory: "/overtime-management/overtime-history",
	overtimeRequests: "/overtime-management/overtime-requests",
	overtimeTeamHistory: "/overtime-management/overtime-team-history",
	claimSummary: "/claim-management/claim-summary",
	claimHistory: "/claim-management/claim-history",
	claimPending: "/claim-management/claim-pending",
	assignment: "/e-learning/assignment-history",
	ongoingAssigment: "/e-learning/ongoing/assignment",
	certificate: "/e-learning/certificate",
	signUp: "/signup",
	createPassword: "/signup/create-password",
	pageAppointmentSession: "/appointment/page-appointment",
	pageUpcoming: "/appointment/page-upcoming",
	resetPassword: "/forgot-password",
	verifyResetEmail: "/forgot-password/verify-email",
	
};

export default pathnames;
